import React, { Component } from 'react';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";

import { AlumnosXCarrera, DatosRendimiento } from '../../funciones/functionEstadistica';

import ModalReports from '../../components/Reportes/ModalReports';
import RendimientoPorCarrera from '../../components/Reportes/RendimientoPorCarrera';

class AlumnosCarrera extends Component {
    state = {
        datosC: <div align = "center" className="text-danger"><i className="fa fa-spinner fa-spin"></i> Cargando datos</div>,
        datosT: "",
        btnAcciones: {icon: "fa fa-cogs", text: "Acciones", disabled: false},
        openW:false,
        data: ""
    }

    componentDidMount = () => {
        let  { btnAcciones } = this.state;

        AlumnosXCarrera(this.props.datos.value, (resp) => {
            let porcentajeM = (resp.M * 100) / resp.Total;
            let porcentajeF = (resp.F * 100) / resp.Total;

            const styles = {
                padding: 5, fontSize: 12, cursor: "pointer"
            }

            let contenido = <Row>
                                <Col md = {12}>
                                    <div className="custom-alert-warning" style={{fontSize: 11}}>Datos estadísticos de <strong>{this.props.datos.label}</strong></div>
                                </Col>
                                <Col md = {6} className="custom-mt-10">
                                    <div style={{fontSize:10}} className="text-danger">Femenino <span className="text-muted"><strong>({resp.F})</strong> estudiantes</span></div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeF)}%`, backgroundColor:"#A0555C"}}>
                                            {Math.round(porcentajeF)}%
                                        </div>
                                    </div>
                                </Col>
                                <Col md = {6} className="custom-mt-10">
                                    <div style={{fontSize:10}} className="text-danger">Masculino <span className="text-muted"><strong>({resp.M})</strong> estudiantes</span></div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeM)}%`, backgroundColor:"#1f2f6e"}}>
                                            {Math.round(porcentajeM)}%
                                        </div>
                                    </div>
                                </Col>
                            </Row>
            
            let printList = (
                <Popover>
                    <div style={styles}><i className="text-danger fa fa-file-o"></i> Listado de Estudiantes (Aula Virtual)</div>
                    <div style={styles} onClick = {this.printRendimiento}><i className="text-danger fa fa-university"></i> Rendimiento Estudiantil</div>
                </Popover>
            )

            this.setState({
                datosC: contenido,
                datosT: <Row>
                            <Col md = {6}>
                                <div style={{fontSize:12}} className="text-danger">Inscritos:</div>
                                <div style={{fontSize:12}} className="text-muted"><strong>({resp.Total})</strong> estudiantes</div>
                            </Col>
                            <Col md = {6}>
                                <OverlayTrigger trigger="focus" placement="bottom" overlay={printList}>
                                    <button className="btn btn-primary btn-sm" title="Opciones de Impresión" style={{borderWidth: 1, marginTop:5}} disabled = {btnAcciones.disabled}><i className = {btnAcciones.icon}></i> {btnAcciones.text}<i className="fa fa-caret-down"></i></button>
                                </OverlayTrigger>
                            </Col>
                        </Row>
            })
        })
    }

    printRendimiento = () => {
        let  { btnAcciones } = this.state;

        if  (btnAcciones.disabled === true) return null;

        this.setState({
            btnAcciones: {icon: "fa fa-spinner fa-spin", text: "Espera", disabled: true}
        }, () => {
            DatosRendimiento(this.props.datos.value, (resp) => {
                this.setState({
                    btnAcciones: {icon: "fa fa-cogs", text: "Acciones", disabled: false},
                    data: resp,
                    openW: true
                })
            })
        })
    }

    preloader = () => {
        let  { btnAcciones } = this.state;

        if  (btnAcciones.disabled === false) return null;

        return (
            <div className = 'bgr-preloader'>
                <div align = "center" className = 'custom-proloader-i'>
                    <i className = 'fa fa-spinner fa-spin'/>
                    <div>Generando el Reporte</div>
                </div>
            </div>
        )
    }

    modal = () => {
        if (this.state.openW === false) return null

        return (
            <ModalReports
                reporte = {<RendimientoPorCarrera />}
                titulo = {`Rendimiento Académico de los Estudiantes de ${this.props.datos.label}`}
                display = "block"
                cerrar = {() => {this.setState({openW:false})}}
            />
        )
    }

    render() {
        let {datos} = this.props;
        let {datosC, datosT} = this.state;

        const styles = {
            padding: 10, fontSize: 12
        }

        const styles2 = {
            padding: 10, fontSize: 14
        }

        return (
            <React.Fragment>
                <tr>
                    <td style={styles2}>
                        <strong>{datos.label}</strong>
                        {datosT}
                    </td>
                    <td style={styles}>{datosC}</td>
                </tr>
                {this.preloader()}
                {this.modal()}
            </React.Fragment>
        );
    }
}
 
export default AlumnosCarrera;


// WEBPACK FOOTER //
// ./src/views/Opciones/AlumnosCarrera.jsx